import React, {Component} from "react";
import PropTypes from "prop-types";

import {
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Row,
    Col,
} from "reactstrap";

// Helper functions
import { cloneDeep, isEmpty } from 'lodash';
import applyConditionalLogic from "classes/ConditionalLogic.jsx";

// core components
import Field from "components/Features/Field.jsx";

class FieldSet extends Component {
    
    debug = false;
    state = {
        errorFields: []
    };
    
    componentDidMount() {
        // const { currentValues, onChange } = this.props;
        // const { isValid, completion } = this.isValid( currentValues );
        // onChange(currentValues, isValid, completion);
    }
    
    componentDidUpdate( prevProps ){
        const oldOriginalValues = prevProps.originalValues;
        const oldCurrentValues = prevProps.currentValues;
        const { currentValues, originalValues, onChange } = this.props;
        
        if( this.debug ) console.log('Component did update: ',currentValues);
        let updated = false;
        if( oldOriginalValues !== originalValues ){
            if( this.debug ) console.log('Fieldset Component updated (original values): ',originalValues);
            updated = true;
        }
        
        if( currentValues != oldCurrentValues ){
            //FIXME: this is triggered by onChange() - prevent recursion to improve performance
            if( this.debug ) console.log('Fieldset Component updated (current values): ',currentValues);
            updated = true;
        }
        
        if( updated ){
            const { isValid, completion } = this.isValid( currentValues );
            onChange(currentValues, isValid, completion);
        }
    }
    
    /**
     * Apply conditional logic to a field to determine if it should display or not
     *
     * @param conds [object] Conditions object, including Action, Multiple, Criteria keys
     *
     * @return bool Whether field is visible (true) or hidden (false)
     */
    applyConditionalLogic = ( conds, currentValues ) => {
        const { originalValues, fields } = this.props;
        if( typeof currentValues == "undefined" ){
            var currentValues = this.props.currentValues;
        }
        
        return applyConditionalLogic( conds, originalValues, fields, currentValues );
    };
    
    applyConditionalTemplateRaw = ( match, fieldId ) => {
        return this.applyConditionalTemplate( match, fieldId, true );
    };
    
    applyConditionalTemplate = ( match, fieldId, raw ) => {
        const { originalValues, currentValues, fields } = this.props;
        
        if( typeof raw == "undefined" ){
            var raw = false;
        }
        
        if(this.debug) console.log('Applying template for: ', match, fieldId);
        
        // Get default value (& lookup options)
        let fldDefault = '';
        let fldOptions = {};
        for( const fldArea in fields ){
            const fldArray = fields[fldArea];
            fldArray.forEach( (thFld) => {
                if( fieldId === thFld.id ){
                    fldDefault = thFld.default ?? '';
                    fldOptions = thFld.options ?? {};
                }
            });
        }
        match = fldDefault;
        
        // Get field value (server first, then state)
        match = originalValues['meta_'+fieldId] ?? match; // From Server
        match = currentValues[fieldId] ?? match; // From State
        
        // If Option field, apply field value
        if( !raw && typeof fldOptions[match] != "undefined" ){
            match = fldOptions[match];
        }
        if(this.debug) console.log(' - Applied: ', match);
        
        return match;
    };
    
    isValid = ( newValues ) => {
        const { name, originalValues, fields } = this.props;
        
        const fieldData = fields[name] ?? fields;
        if( isEmpty(fieldData) ){
            return true;
        }
        
        let completion = 100; // Completion Percentage
        let isValid = true;
        let invalidFields = [];
        let numFields = 0;
        fieldData.map((fld, i)=>{
            // Get field value (first State, then Saved, then default)
            let fldValue = newValues[fld.id] ?? originalValues['meta_'+fld.id] ?? fld.default;
            // Apply default value conditional template
            if( typeof fldValue == "string" && '' != fldValue ){
                fldValue = fldValue.replace(/\${_([\w_-]+)}/g, this.applyConditionalTemplate);
            }
            const requiredFld = fld.required ?? false;
            const conditions = fld.conditions ?? {};
            const visible = this.applyConditionalLogic( conditions, newValues );
            if( !visible ) // Don't apply checks to invisble fields
                return;
            if( requiredFld ){
                numFields++;
            }
                
            // Check whether field has a value
            if( null == fldValue || '' == fldValue ){
                // Field is blank
                if( requiredFld ){ // is a required field - error: required field has no value
                    isValid = false;
                    if( this.debug ) console.log('Invalid field detected: ',fld.id,fldValue);
                    invalidFields.push( fld.id );
                }
            } else {
                // Field has a value
                if( this.debug ) console.log('FLD Value: ',fldValue);
                // Check field validation regex
                const fieldRegex = fld.regex ?? '';
                if( 'central_branch' == fld.id ){
                    console.log('Branch field regex: ',fieldRegex);
                }
                if( '' == fieldRegex )
                    return;
                if( 'central_branch' == fld.id ){
                    console.log('Branch field regex2: ',fieldRegex);
                }
                let validator = null;
                try{ // Convert fld.regex to a JS regexp object
                    validator = new RegExp(fieldRegex);
                    if( this.debug ) console.log('Testing value against regex: ',fldValue, fieldRegex);
                } catch (e){
                    console.warn("Failed to parse regex: ",fieldRegex);
                    return; //error out
                }
                if( !validator.test(fldValue) ){
                    isValid = false;
                    if( this.debug ) console.log('Invalid field detected: ',fld.id,fldValue,fieldRegex);
                    invalidFields.push( fld.id );
                    if( !requiredFld ){ // Make bar turn red if this isn't a required field
                        numFields++;
                    }
                }
            }
        });
        
        if( this.debug ) console.log('Validity check for area ',name,' errors: ',invalidFields);
        
        this.setState({errorFields:invalidFields});
        
        // Calculate completion percentage
        if( !isValid ){
            const numErrors = invalidFields.length;
            completion = Math.floor( 100 - (numErrors/numFields * 100) );
        }
        
        return { isValid, completion };
    };
    
    render(){
        const {
            errorFields
        } = this.state;
        const {
            name,
            title,
            fields,
            originalValues,
            currentValues,
            onChange,
            isVisible,
            readOnly,
            showInvalidFields,
            className,
            header,
            footer,
            key,
        } = this.props;
        
        const fieldData = fields[name] ?? fields;
        if( isEmpty(fieldData) ){
            return null;
        }
        
        let fld_num = 0;
        
        let cardKey = key;
        if( null == cardKey ){
            cardKey = name;
        }
        return (
            <Card key={cardKey} className="fieldset_wrapper">
                <CardHeader className="border-0">
                    <Row className="align-items-center">
                        <div className="col">
                            <h2 className="mb-0">{title}</h2>
                        </div>
                    </Row>
                    
                    {(null!=header)?(
                        <>
                        {header}
                        </>
                    ):null}
                </CardHeader>
                <CardBody className="pt-0">
                    <Row className="cf">
                    {fieldData.map((fld, i)=>{
                        const width = fld.width ?? '12';
                        const width_sm = fld.sm_width ?? width;
                        
                        if( 'hidden' == fld.type ){
                            // Skip hidden fields
                            return null;
                        }
                        
                        const conditions = fld.conditions ?? {};
                        const visible = this.applyConditionalLogic( conditions );
                        if( !visible ){
                            // Field is hidden via conditional logic
                            return null;
                        }
                        
                        if( typeof fld.label == "undefined" ){
                            // Is a spacer
                            return ( <Col key={i} sm={width_sm} md={width} /> );
                        }
                        
                        const fldReadOnly = fld.readonly ?? false;
                        
                        let fldValue = originalValues['meta_'+fld.id] ?? (fld.default??null);
                        // Apply default value conditional template
                        if( typeof fldValue == "string" && '' != fldValue ){
                            fldValue = fldValue.replace(/\${_([\w_-]+)}/g, this.applyConditionalTemplateRaw);
                        }
                        if( !fldReadOnly ){
                            // Look at state values
                            fldValue = currentValues[fld.id] ?? fldValue;
                        }
                        
                        const fldRequired = fld.required ?? false;
                        let reqStar = null;
                        if( fldRequired ){
                            reqStar = (<span className="fld-required">*</span>)
                        }
                        
                        let fldError = false;
                        if( showInvalidFields && errorFields.includes(fld.id) ){
                            fldError = true;
                        }
                                        
                        return (
                            <Col key={i} sm={width_sm} md={width}>
                                {(fld_num++>0&&'instructions'==fld.type&&'12'==width)?(
                                    <br />
                                ):(null)}
                                
                                {''!=fld.label?(
                                    <>
                                    {'description'==fld.type?(
                                        <h3 className="fld_desc">{fld.label}</h3>
                                    ):(
                                        <><strong>{fld.label} {reqStar}</strong><br /></>
                                    )}
                                    </>
                                ):null}
                                
                                <Field
                                    type={fld.type??'text'}
                                    subType={fld.subType??null}
                                    options={fld.options??{}}
                                    value={fldValue}
                                    placeholder={fld.placeholder??''}
                                    fldRequired={fldRequired}
                                    readonly={readOnly||fldReadOnly}
                                    error={fldError}
                                    helperText={fld.desc??''}
                                    fldId={fld.id}
                                    step={fld.step??null}
                                    min={fld.min??null}
                                    max={fld.max??null}
                                    maxlength={fld.maxlength??null}
                                    rows={fld.rows??null}
                                    map={fld.map??{}}
                                    onChange={(newValue, otherValues) => {
                                        if( readOnly||fldReadOnly ){
                                            return;
                                        }
                                        let newValues = cloneDeep(currentValues);
                                        newValues[fld.id] = newValue;
                                        if(this.debug) console.log('Field updated: ', fld.id, newValue, newValues);
                                        if( typeof otherValues != "undefined" ){
                                            for (const ind in otherValues) {
                                                newValues[ind] = otherValues[ind];
                                            }
                                        }
                                        const { isValid, completion } = this.isValid( newValues );
                                        onChange(newValues, isValid, completion);
                                    }}
                                    terms={fld.terms??[]}
                                    logicFn={this.applyConditionalLogic}
                                    templateFn={this.applyConditionalTemplate}
                                    isVisible={isVisible}
                                    errorText={fld.errorText??null}
                                    className={'wb_input_fld'}
                                />
                            </Col>
                        );
                    })}
                    </Row>
                </CardBody>
                {(null!=footer)?(
                    <CardFooter>
                        {footer}
                    </CardFooter>
                ):null}
            </Card>
        );
    }
}

FieldSet.propTypes = {
    name: PropTypes.string,
    title: PropTypes.string,
    fields: PropTypes.object,
    originalValues: PropTypes.object,
    currentValues: PropTypes.object,
    onChange: PropTypes.func,
    isVisible: PropTypes.bool,
    readOnly: PropTypes.bool,
    showInvalidFields: PropTypes.bool,
    className: PropTypes.string,
    header: PropTypes.node,
    footer: PropTypes.node,
    key: PropTypes.string,
};

FieldSet.defaultProps = {
    name: '',
    title: '',
    fields: {},
    originalValues: {},
    currentValues: {},
    onChange: (newVals, isValid, completion) => {console.log('Values updated: ',onChange)},
    isVisible: false,
    readOnly: false,
    showInvalidFields: false,
    className: "",
    header: null,
    footer: null,
    key: null,
}

export default FieldSet;
